// Zodiac Icons Index
// Export each zodiac sign SVG for easy importing (new-icon set)

import { ReactComponent as Rat } from "./new-icon/rat.svg";
import { ReactComponent as Ox } from "./new-icon/cow.svg";
import { ReactComponent as Tiger } from "./new-icon/tiger.svg";
import { ReactComponent as Rabbit } from "./new-icon/rabbit.svg";
import { ReactComponent as Dragon } from "./new-icon/dragon.svg";
import { ReactComponent as Snake } from "./new-icon/snake.svg";
import { ReactComponent as Horse } from "./new-icon/horse.svg";
import { ReactComponent as Goat } from "./new-icon/goat.svg";
import { ReactComponent as Monkey } from "./new-icon/monkey.svg";
import { ReactComponent as Rooster } from "./new-icon/chicken.svg";
import { ReactComponent as Dog } from "./new-icon/dog.svg";
import { ReactComponent as Pig } from "./new-icon/pig.svg";

export {
  Rat,
  Ox,
  Tiger,
  Rabbit,
  Dragon,
  Snake,
  Horse,
  Goat,
  Monkey,
  Rooster,
  Dog,
  Pig,
};

// Mapping object for easy access by name
const ZodiacIcons = {
  rat: Rat,
  ox: Ox,
  tiger: Tiger,
  rabbit: Rabbit,
  dragon: Dragon,
  snake: Snake,
  horse: Horse,
  goat: Goat,
  monkey: Monkey,
  rooster: Rooster,
  dog: Dog,
  pig: Pig,
};

export default ZodiacIcons;
